import React from "react";
import { getAllProductsIMG } from "../../services/api";

export default function DeleteConfirmModal({ item, onConfirm, onCancel }) {
  if (!item) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center bg-black/40">
      
      {/* Bottom Sheet */}
      <div className="w-full max-w-md bg-white rounded-t-2xl p-4 animate-slideUp">

        {/* Header */}
        <div className="flex justify-between items-center mb-3">
          <h2 className="text-sm font-medium">
            Do you want to remove 1 item?
          </h2>
          <button onClick={onCancel} className="cursor-pointer hover:bg-gray-100 rounded-full w-[1.9rem] h-[1.9rem] text-center">✕</button>
        </div>

        {/* Item */}
        <div className="flex items-center gap-3 mb-4">
          <img
            src={`${getAllProductsIMG}/${item.image}`}
            alt={item.name}
            className="w-14 h-14 rounded-lg object-contain bg-gray-100"
          />

          <div className="flex-1">
            <p className="text-sm text-gray-700">
              {item.name.slice(0, 30)}...
            </p>
            <p className="text-xs text-gray-500">{item.size} ml</p>
          </div>

          <div className="text-right">
            <p className="text-sm font-medium">₹{item.price}</p>
            <p className="text-xs line-through text-gray-400">
              ₹{item.mrp}
            </p>
          </div>
        </div>

        {/* Action */}
        <button
          onClick={onConfirm}
          className="w-full bg-black text-white py-3 rounded-xl font-medium cursor-pointer"
        >
          Yes, remove
        </button>
      </div>
    </div>
  );
}